export default __webpack_public_path__ + "static/senoplast_color-d789b9e909fb022dc181da489a00fc34.png";